<template>
  <div id="loop" class="center"></div>
  <div id="bike-wrapper" class="center">
    <div id="bike" class="centerBike"></div>
  </div>
</template>

<style scoped>
/* Note: body styles should usually be in a global CSS file,
   but kept here for your specific setup */
:global(body) {
  background: black;
  overflow: hidden;
}

/* 1. THE LOOP (Circle)
   Original 100px * 2.5 = 250px
*/
.center {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -125px; /* Half of height */
  margin-left: -125px; /* Half of width */
}

#loop {
  height: 250px;
  width: 250px;
  border: #bb5f27 solid 10px; /* Thicker border for scale */
  border-radius: 500px;
}

/* 2. THE RUNWAY (Line)
   Original 300px * 2.5 = 750px
*/
#loop:before {
  background: linear-gradient(to left, rgba(187, 95, 39, 0) 0%, rgba(187, 95, 39, 1) 30%, rgba(187, 95, 39, 1) 70%, rgba(187, 95, 39, 0) 100%);
  content: "";
  display: block;
  height: 10px;
  left: -250px; /* Adjusted offset */
  position: relative;
  top: 250px;   /* Positioned at bottom of loop */
  width: 750px;
}

/* 3. THE BIKE WRAPPER
   Scales the rotation radius
*/
#bike-wrapper {
  height: 270px; /* 108 * 2.5 */
  width: 270px;  /* 108 * 2.5 */
  animation: drive 3s linear infinite;
}

/* 4. THE MOTORBIKE
   Original ~25px * 2.5 = 62.5px
*/
.centerBike {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: 65px;   /* Adjusted centering for bike height */
  margin-left: -30px; /* Adjusted centering for bike width */
}

#bike {
  height: 60px;
  width: 62px;
  background-image: url("/motorbike.png");
  background-size: contain;
  background-repeat: no-repeat;
}

/* 5. THE ANIMATION
   Offsets scaled by 2.5
*/
@keyframes drive {
  0% {
    margin-left: -910px; /* -364 * 2.5 */
    opacity: 0;
  }
  33.33% {
    transform: rotate(0deg);
    margin-left: -125px; /* -50 * 2.5 */
    opacity: 1;
  }
  66.66% {
    transform: rotate(-360deg);
    margin-left: -125px;
    opacity: 1;
  }
  100% {
    margin-left: 660px; /* 264 * 2.5 */
    transform: rotate(-360deg);
    opacity: 0;
  }
}
</style>